import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@apple/features/auth/utils/require-auth';

export const Route = createFileRoute('/_authed')({
	beforeLoad: args => {
		requireAuth(args);
	},
});
